import adu from "../src/Assets/Images/adu.jpeg"
import david from "../src/Assets/Images/david.jpg"
import luna from "../src/Assets/Images/luna.jpg"
import rex from "../src/Assets/Images/rex.jpg"
import vee from "../src/Assets/Images/vee.jpg"

export const data = [
    {
        id: 1,
        name: "Rexford Brefo",
        age: 21,
        pic: rex
    },
    {
        id: 2,
        name: "Valerie Ofori",
        age: 21,
        pic: vee
    },
    {
        id: 3,
        name: "Adu Boat",
        age: 20,
        pic: adu
    },
    {
        id: 4,
        name: "Melody",
        age: 26,
        pic: "https://theviraler.com/wp-content/uploads/2021/11/60-hot-pictures-of-reign-edwards-that-are-sure-to-make-you-her-biggest-fan-best-of-comic-books-39.jpg"
    },
    {
        id: 5,
        name: "Luna",
        age: 19,
        pic: luna
    },
    {
        id: 6,
        name: "David",
        age: 18,
        pic: david
    }
]